<div class="table-row">
  <div class="table-item">{{ debate.questionTitle }}</div>
  <div class="table-item">{{ debate.session }}</div>
  <div class="table-item">
    <span [ngClass]="status.votesStyle">
      <i class="glicon-thumb-up font-20 margin-right-gap green-text"></i>
      <span class="margin-right-gap">{{ positiveVotePercentage }} %</span>
      <i class="glicon-thumb-down font-20 margin-right-gap red-text"></i>
      <span>{{ negativeVotePercentage }} %</span>
    </span>
  </div>
  <div class="table-item">{{ numOpinions }}</div>
  <div class="table-item">
    {{ status.dispute | translate }}
    <span [ngClass]="status.styleClass">({{ status.groupQuestion | translate }})</span>
  </div>
  <div class="table-item">
    <gl-button
      icon
      icon-center="glicon-down-arrow"
      (onClick)="details.toggleState()"
      class="right"
      title="{{ 'actions.showInfo' | translate }}"
      *lmsProfileGuard="'clients.row-detail'"
    >
    </gl-button>
    <gl-button
      icon
      icon-center="glicon-edit"
      [routerLink]="['/tutorization/debates', debate.id]"
      class="right"
      title="{{ 'actions.edit' | translate }} {{ debate.questionTitle }}"
    >
    </gl-button>
  </div>
</div>
<lms-list-row-detail #details>
  <div *ngIf="this.questionInfo && this.questionInfo.choices != undefined">
    <ul class="list">
      <li class="heading">{{ debate.questionTitle }}</li>
      <li *ngFor="let choices of this.questionInfo.choices; let i = index">
        <span
          [ngClass]="{
            'green-text': this.questionInfo.choices[i].isCorrect,
            'red-text': !this.questionInfo.choices[i].isCorrect
          }"
          >{{ this.questionInfo.choices[i].text }}
        </span>
      </li>
    </ul>
  </div>
</lms-list-row-detail>
